import React from 'react'
import Grid from '../commonComponents/Grid'
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import SortDatasetWiseParent from './SortDatasetWiseParent';
import SortDashboardWiseParent from './SortDashboardWiseParent'
import NoDataFound from '../commonComponents/NoDataFound';
import LoadingComponent from '../commonComponents/LoadingComponent';

var boxData = null, moreOptions, subMenuOptions = []

const MonitoringGridComponent = ({ allProps, allStates, setDataFunction, handleBreakdown, handleRightClickOption, dashboardData, handleSortBy, datasetData, handleGlobalFilter }) => {
    // var sortFormVar = {
    //     "sortByFilter": {
    //         "name": "sortByFilter",
    //         "key": `sortKey${Math.floor(Math.random() * 10)}`,
    //         "type": "dropdown",
    //         "text_value": allStates.sortValue,
    //         "options": [
    //             { "name": "Sort By", "value": "", disabled: true, selected: true },
    //             { "name": "A - Z", "value": "alphabetically" },
    //             { "name": "Z - A", "value": "de-alphabetically" },
    //             // { "name": "Frequently used", "value": "used" },
    //             // { "name": "Created date", "value": "created_date" },
    //             { "name": "Last updated", "value": "time" }
    //         ],
    //         "requiredFlag": false,
    //         multiple: false
    //     }
    // }

    const handleFavourite = () => {
        alert("Favourite Marked")
    }
    const handleArchive = () => {
        alert("archive Marked")
    }
    var boxClassName = 'justify-content-center'
    if (allStates.tabId == 'datasets') {
        moreOptions = [
            { "id": "openDataset", "name": "Open Dataset", "icon": "database", "eventFunction": setDataFunction },
            { "id": "globalFilter", "name": "Global Filter", "icon": "filter", "eventFunction": handleGlobalFilter },
        ]
        subMenuOptions = [
            { "id": "dashboards", "name": "Dashboards", "icon": "database", "type": "function" },
            { "id": "reports", "name": "Reports", "icon": "database", "type": "function" }
        ]
        // sortFormVar['sortByFilter']['options'].push({ "name": "Default", "value": "" })

        var filteredData = JSON.parse(JSON.stringify(datasetData))
        if (allStates.sortValue) {
            filteredData = handleSortData(allStates.sortValue == 'de-alphabetically' ? "descending" : "ascending", allStates.sortValue, filteredData, 'name')
        }
        if (filteredData.length == 0) {
            if (allStates.searchValue != '') {
                filteredData = <NoDataFound information='No Dataset Found! Try Searching Another one.' hideImg={false} status={-1} style={false} />
            } else {
                filteredData = <LoadingComponent messages={["Your Datasets are loading!"]} />
            }
        } else boxClassName = ''

        boxData = Array.isArray(filteredData) && filteredData.length > 0
            ? filteredData.map((eachValue, index) => {
                if (allProps.authData.companyName == 'Deloitte') {
                    let srcURL = eachValue.name.toLowerCase()
                    let srcFile;
                    if (['risk advisory', 'balance scorecard', 'process audit'].includes(srcURL)) {
                        srcFile = '/assets/sampleFile/deloitte.png'
                    } else {
                        srcFile = `/assets/sampleFile/${srcURL}.png`
                    }
                    if (srcFile) {
                        var imageTag = <img className={`img ${eachValue.name == 'Audi' || eachValue.name ? 'wd-60' : "wd-30"} ht-30`} src={srcFile} onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = '/assets/sampleFile/default-database.svg' // Append icon container to the image parent
                            e.target.style.width="35px"
                            e.target.style.height="40px"
                            e.target.style.color="rgb(77, 149, 252)"
                        }} />
                    } else {
                        var iconTag = <i className='fas fa-database desc-btn db-icon mg-t-10 mg-r-5' onClick={() => setDataFunction(eachValue)} style={{ color: "#4D95FC" }}></i>
                    }
                } else {
                    var iconTag = <i className='fas fa-database desc-btn db-icon mg-t-10 mg-r-5' onClick={() => setDataFunction(eachValue)} style={{ color: "#4D95FC" }}></i>
                }
                return (
                    <Grid
                        tabId={allStates.tabId}
                        id={`dataset_${eachValue.toolId}`}
                        key={`dataset_${eachValue.toolId}_${index}`}
                        iconTag={iconTag}
                        imageTag={imageTag}
                        title={eachValue.name}
                        mediaBodyId={`toolId_${eachValue.toolId}`}
                        folderDetails={eachValue}
                        datasetFolderEvent={setDataFunction}
                        description={`${eachValue.total_cols} Columns, ${eachValue.total_rows} Rows`}
                        additionalDescription={eachValue.table_size ? `${eachValue.table_size} Size` : null}
                        lastTime={eachValue.last_updated_time}
                        moreOptions={moreOptions}
                        subMenuOptions={subMenuOptions}
                        eventMore={handleBreakdown}
                    />
                );
            })
            : filteredData
    } else if (allStates.tabId == 'dashboards') {
        moreOptions = [
            { "id": "openDashboard", "name": "Open Dashboard", "icon": "folder", "type": "url", "target": "_blank" }
        ]
        subMenuOptions = [
            { "id": "dashboards", "name": "Reports", "icon": "file-text", "type": "function" },
            { "id": "datasets", "name": "Dataset", "icon": "database", "type": "function" }
        ]
        // if (allStates.datasetFilterToolId) {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "Default", "value": "" })
        // } else {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "By Dataset", "value": "dataset", 'notVisible': 'datasets' }, { "name": "Default", "value": "" })
        // }

        var filteredData = JSON.parse(JSON.stringify(dashboardData))
        if (allStates.sortValue && allStates.sortValue != 'dataset') {
            filteredData = handleSortData(allStates.sortValue == 'de-alphabetically' ? "descending" : "ascending", allStates.sortValue, filteredData, 'dashboard_group')
        }
        if (filteredData.length == 0) {
            filteredData = <NoDataFound data='No Dashboards Found! Try Searching Another one.' hideImg={false} status={-1} style={false} />


        } else boxClassName = ''

        boxData = Array.isArray(filteredData) && filteredData.length > 0
            ? allStates.sortValue == 'dataset'
                ? <SortDatasetWiseParent
                    renderData={filteredData}
                    tabId={allStates.tabId}
                    handleRightClickOption={handleRightClickOption}
                    moreOptions={moreOptions}
                    subMenuOptions={subMenuOptions}
                    handleBreakdown={handleBreakdown}
                    setDataFunction={setDataFunction}
                    handleFavourite={handleFavourite}
                    handleArchive={handleArchive}
                ></SortDatasetWiseParent>
                : filteredData.map((eachValue, index) => {
                    return (
                        <Grid
                            tabId={allStates.tabId}
                            id={`dashboard_${eachValue.dashboard_group}`}
                            key={`dashboard_${eachValue.dashboard_group}_${index}`}
                            title={eachValue.dashboard_group}
                            mediaBodyId={`dashboardGroup_${eachValue.dashboard_group}`}
                            folderDetails={eachValue}
                            datasetFolderEvent={handleRightClickOption}
                            // description={`${allDashboards.dashbordGroups.length} Reports`}
                            additionalDescription={eachValue.dataset_name}
                            lastTime={eachValue.last_updated_time}
                            openDataSet={setDataFunction}
                            moreOptions={moreOptions}
                            subMenuOptions={subMenuOptions}
                            eventMore={handleBreakdown}
                            stateChange={true}
                        />
                    );
                })
            : filteredData
    } else if (allStates.tabId == 'reports') {
        let reportsData = null
        if (allStates.data?.reportsData?.status) {
            reportsData = allStates.data?.reportsData?.information
            boxClassName = ''
        } else if (allStates.data?.reportsData?.status == false) {
            reportsData = <NoDataFound data='No Reports Found! Try Searching Another one.' hideImg={true} status={-1} style={true} />

        }
        moreOptions = [
            { "id": "openReport", "name": "Open Report", "icon": "file-text", "type": "url", "target": "_blank" },
        ]
        // if (window.location.href.includes('admin')) {
        //     moreOptions = [...moreOptions, { "id": "manageAccess", "name": "Manage Access", "icon": "folder", "type": "function" }
        //     ]
        // }
        subMenuOptions = [
            { "id": "dashboards", "name": "Dashboards", "icon": "folder", "type": "function" },
            { "id": "reports", "name": "Reports", "icon": "file-text", "type": "function" }
        ]
        // if (allStates.datasetFilterToolId && allStates.dashboardFilterName) {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "Default", "value": "" })
        // } else if (allStates.datasetFilterToolId) {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "By Dashboard", "value": "dashboard" }, { "name": "Default", "value": "" })
        // } else if (allStates.dashboardFilterName) {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "By Dataset", "value": "dataset" }, { "name": "Default", "value": "" })
        // } else {
        //     sortFormVar['sortByFilter']['options'].push({ "name": "By Dataset", "value": "dataset" }, { "name": "By Dashboard", "value": "dashboard" }, { "name": "Default", "value": "" })
        // }
        boxData = Array.isArray(reportsData) && reportsData.length > 0
            ? allStates.sortValue == 'dataset'
                ? <SortDatasetWiseParent
                    renderData={reportsData}
                    handleRightClickOption={handleRightClickOption}
                    moreOptions={moreOptions}
                    subMenuOptions={subMenuOptions}
                    handleBreakdown={handleBreakdown}
                    setDataFunction={setDataFunction}
                    handleFavourite={handleFavourite}
                    handleArchive={handleArchive}
                    tabId={allStates.tabId}
                />
                : allStates.sortValue == 'dashboard'
                    ? <SortDashboardWiseParent
                        renderData={reportsData}
                        handleRightClickOption={handleRightClickOption}
                        moreOptions={moreOptions}
                        subMenuOptions={subMenuOptions}
                        handleBreakdown={handleBreakdown}
                        setDataFunction={setDataFunction}
                        handleFavourite={handleFavourite}
                        handleArchive={handleArchive}
                    />
                    : reportsData.map((eachValue, index) => {
                        return (
                            <Grid
                                tabId={allStates.tabId}
                                id={`report_${eachValue.dashboard_id || eachValue.report_id}`}
                                Gkey={`report_${eachValue.dashboard_id || eachValue.report_id}_${index}`}
                                icon='file-text'
                                title={eachValue.reportName ? eachValue.reportName : "-"}
                                mediaBodyId={`reportId_${eachValue.dashboard_id || eachValue.report_id}`}
                                folderDetails={eachValue}
                                datasetFolderEvent={handleRightClickOption}
                                description={eachValue.dashboard_group}
                                additionalDescription={eachValue.datasetName}
                                lastTime={eachValue.dateModified}
                                moreOptions={moreOptions}
                                subMenuOptions={subMenuOptions}
                                eventMore={handleBreakdown}
                                stateChange={true}
                                openDataSet={setDataFunction}
                                handleFavourite={handleFavourite}
                                handleArchive={handleArchive}
                            />
                        );
                    })
            : reportsData
    }


    return (
        <>
            {/* <div className={`d-flex ${screenWidth > mobile_width ? url.includes('admin')  ? 'moveAdminTop justify-content-end' : "moveTop justify-content-end" : 'mg-t-5'}`} >
                <Form label_array={sortFormVar} handle_form_drop_down={(e) => handleSortBy(e)} formGroupWidth={true} formGroupClass='mg-b-0' allStates={allStates} />
            </div> */}
            <div className={`row row-xs ${boxClassName} pd-x-0 `} >
                {boxData ? boxData : <LoadingComponent />}
            </div>
        </>
    )
}

export default MonitoringGridComponent
